import styled from "styled-components";
import dayjs from "dayjs";
import { DatePicker, DatePickerProps } from "../utils/local-antd";
import { useTranslation } from "react-i18next";
import { Info } from "./Info";
import { Flex } from "./Flex";

const RangePicker = styled(DatePicker.RangePicker)`
  width: 15rem;
  height: 2.3rem;
`;

type Props = {
  onChange: (dateStrings: string[]) => void;
  /**
   * Makes the picker controlled. Without it the picker keeps showing a range
   * the caller has already cleared in favour of a preset.
   */
  value?: string[] | null;
  loading?: boolean;
  style?: React.CSSProperties;
  className?: string;
  minDate?: DatePickerProps["minDate"];
  maxDate?: DatePickerProps["maxDate"];
};

export const AtiraDateRange: React.FC<Props> = ({
  onChange,
  value,
  loading,
  style,
  className,
  minDate,
  maxDate,
}) => {
  const { t } = useTranslation();

  return (
    <RangePicker
      className={className}
      value={
        value?.length === 2 && value[0] && value[1]
          ? [dayjs(value[0]), dayjs(value[1])]
          : null
      }
      onChange={(dates, dateStrings) => {
        onChange(dateStrings);
      }}
      disabled={loading}
      style={style}
      renderExtraFooter={() => (
        <Flex marginBlock="s">
          <Info color="warning" info={t("common.filterByDateRange")} />
        </Flex>
      )}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
};
